const CustomTypeModelFieldType = {
  Boolean: "Boolean",
  Color: "Color",
  Date: "Date",
  Embed: "Embed",
  GeoPoint: "GeoPoint",
  Group: "Group",
  Image: "Image",
  Integration: "IntegrationFields",
  Link: "Link",
  Number: "Number",
  Select: "Select",
  Slices: "Slices",
  StructuredText: "StructuredText",
  Text: "Text",
  Timestamp: "Timestamp",
  UID: "UID",
  /**
   * @deprecated - Renamed to `Integration`.
   */
  IntegrationFields: "IntegrationFields",
  /**
   * @deprecated - Legacy field type. Use `Number` instead.
   */
  Range: "Range",
  /**
   * @deprecated - Legacy field type. Do not use.
   */
  Separator: "Separator",
  /**
   * @deprecated - Legacy field type. Use `Slices` instead.
   */
  LegacySlices: "Choice"
};
export {
  CustomTypeModelFieldType
};
//# sourceMappingURL=types.js.map
